import AddCardIcon from "@mui/icons-material/AddCard";
import ListOnlinePayments from "./List";
import { ONLINE_PAYMENTS, PaymentServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <AddCardIcon />,
  name: PaymentServicePath + ONLINE_PAYMENTS,
  title: "Електронни плащания",
  list: <ListOnlinePayments />,
  permission: permissions.canPreviewOnlinePayments,
};
